import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import QualityControlOrdersList from './list';
import QualityControlOrdersCreate from './create';
import PartsAssignmentInQualityControlOrders from './partsAssignment';
import TasksAssignmentInQualityControlOrders from './tasksAssignment';
import QualityControlInvoicing from './invoice';

export const qualityAssuranceOrdersRoutes = [
  {
    'component': <QualityControlInvoicing />,
    'path': paths.QualityControlInvoicing,
  },
  {
    'component': <QualityControlOrdersList />,
    'path': paths.QualityControlAccessoriesOrdersList,
  },
  {
    'component': <QualityControlOrdersCreate />,
    'path': paths.QualityControlAccessoriesOrdersCreate,
  },
  {
    'component': <PartsAssignmentInQualityControlOrders />,
    'path': paths.PartsAssignmentInQualityControlOrders,
  },
  {
    'component': <TasksAssignmentInQualityControlOrders />,
    'path': paths.TasksAssignmentInQualityControlOrders,
  },
];
